import { render, staticRenderFns } from "./AccountProjectSection.vue?vue&type=template&id=0d112048"
import script from "./AccountProjectSection.vue?vue&type=script&lang=js"
export * from "./AccountProjectSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports